import { GetterTree } from 'vuex'
import { RootState } from '@/app/common/types/root-state.type'
import { DossierState } from './state'

export const getters: GetterTree<DossierState, RootState> = {

}
